import React, { Component } from 'react'

import Repository from '../../felles/repository'
import Maalertyper from './maalertyper'
import { resolve } from '../../dependencies'
import Lodading from '../../felles/loading'

export default class MaalertyperContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            maalertyper: [],
            fabrikat: [],
            typer: [],
            dimensjon: [],
            retning: [],
            kapasitet: [],
            laster: false
        }

        this._repository = new Repository()

        this._onDataMotattMaalere = this._onDataMotattMaalere.bind(this)
        this._onDataMotattFabrikat = this._onDataMotattFabrikat.bind(this)
        this._onDataMotattTyper = this._onDataMotattTyper.bind(this)

        this._onDataDimensjon = this._onDataDimensjon.bind(this)

        this._onDataRetning = this._onDataRetning.bind(this)

        this._oppdaterliste = this._oppdaterliste.bind(this)

        this._onDataKapasitet = this._onDataKapasitet.bind(this)
    }

    componentDidMount() {
        this.setState({
            laster: true
        })
        resolve(Repository)
            .hentEgendefinerteMaalertyper()
            .then(this._onDataMotattMaalere)
        resolve(Repository)
            .hentFabrikat()
            .then(this._onDataMotattFabrikat)
        resolve(Repository)
            .hentVannmalerTyper()
            .then(this._onDataMotattTyper)
        resolve(Repository)
            .hentDimensjon()
            .then(this._onDataDimensjon)
        resolve(Repository)
            .hentRetning()
            .then(this._onDataRetning)
        resolve(Repository)
            .hentKapasitet()
            .then(this._onDataKapasitet)
        this.setState({
            laster: false
        })
    }

    _onDataMotattMaalere(liste) {        
        this.setState({
            maalertyper: liste,
            laster: false
        })
    }

    _onDataKapasitet(liste) {
        this.setState({
            kapasitet: liste,
            laster: false
        })
    }

    _onDataMotattFabrikat(liste) {
        this.setState({ fabrikat: liste })
    }

    _onDataMotattTyper(liste) {
        this.setState({ typer: liste })
    }

    _onDataDimensjon(liste) {
        this.setState({ dimensjon: liste })
    }

    _onDataRetning(liste) {
        this.setState({ retning: liste })
    }

    _oppdaterliste() {
        this.setState({
            laster: true
        })
       
        resolve(Repository)
            .hentEgendefinerteMaalertyper()
            .then(this._onDataMotattMaalere)
    }

    render() {
        return (
            <div>
                {this.state.laster ? (
                    <Lodading tekst="Henter typer.." />
                ) : (
                    <Maalertyper
                        maalertyper={this.state.maalertyper}
                        fabrikat={this.state.fabrikat}
                        typer={this.state.typer}
                        oppdaterliste={this._oppdaterliste}
                        dimensjon={this.state.dimensjon}
                        retning={this.state.retning}
                        kapasitet={this.state.kapasitet}
                        
                    />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/innstillinger/maalertyper/maalertyperContainer.jsx